import { industries } from './industries';
import { occupations } from './occupations';
var path = '/common';
var common = function (url) { return function () { return ({
    industries: industries(url + path),
    occupations: occupations(url + path),
    post: function () { return ({}); },
}); }; };
export default common;
